/**
 * - Description -
 * AppService contains all the methods that allows the webapp to make some utils function.
 *
 */
/*
class AppService {
    static determineDragAndDropCapable() {
        // Determines if the drag and drop functionality is in the window
        // Create a test element to see if certain events are present that let us do drag and drop.
        let div = document.createElement("div");

        /!* Check to see if the `draggable` event is in the element
         * or the `ondragstart` and `ondrop` events are in the element. If
         * they are, then we have what we need for dragging and dropping files.
         *
         * We also check to see if the window has `FormData` and `FileReader` objects
         * present so we can do our AJAX uploading
         *!/
        let condition = (("draggable" in div) || ("ondragstart" in div && "ondrop" in div))
            && "FormData" in window
            && "FileReader" in window;
        div.remove();
        return condition;
    }
}
module.exports = AppService;
*/

export default {
    name: 'AppService',
    determineDragAndDropCapable: determineDragAndDropCapable
}

function determineDragAndDropCapable() {
    // Determines if the drag and drop functionality is in the window
    // Create a test element to see if certain events are present that let us do drag and drop.
    let div = document.createElement('div');

    /* Check to see if the `draggable` event is in the element
     * or the `ondragstart` and `ondrop` events are in the element. If
     * they are, then we have what we need for dragging and dropping files.
     *
     * We also check to see if the window has `FormData` and `FileReader` objects
     * present so we can do our AJAX uploading
     */
    let condition = (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window;
    div.remove();
    return condition;
}

